import { IonFooter, IonHeader, IonInput, IonTextarea, IonToolbar } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { Icons } from '../../assets/icons/chatbotIcons';
import { loggedInUserService } from '../../services/loggedInUser.service';
import MessageList from './components/messageList.tsx/MessageList';
import SpeechToTextRecognition from './components/speechToTextRecognition/SpeechToTextRecognition';
import WelcomePrompts from './components/welcomePrompts/WelcomePrompts';
import { useChatbot } from './service/useChatbot';
import { CONSTANTS } from '../../constants';
import { StorageService, utilService } from '../../services';
import './chatbot.scss';

const Chatbot = () => {

  const [isChatOpen, setIsChatOpen] = useState(false);
  const [inputText, setInputText] = useState('');
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const { messages, sendMessage, clearMessages, isStreaming } = useChatbot();

    const storageKey = CONSTANTS.STORAGE[utilService.getSavePasswordStatus() ? 1 : 0];
  
    const getItem = (key: string) => StorageService.getStorageItem(storageKey, key, true);

    const loggedInUserName = getItem("firstName") || "there";

 const detectThemeFromBody = () => {
  const isDark = document.body.classList.contains("dark-theme");
  setIsDarkMode(isDark);
};

  useEffect(() => {
    detectThemeFromBody();

    const observer = new MutationObserver(() => detectThemeFromBody());

    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
  const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
    const user = data?.userData;
    setIsLoggedIn(!!user);
  });

  return () => subscription.unsubscribe();
}, []);

  // Toggle chat panel
  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  // Start a new chat
  const startNewChat = () => {
    setInputText('')
    clearMessages();
  };


    const showPromptPage = () => {
    // setInputText('')
    clearMessages();
  };
  // Handle input change
  const handleInputChange = (e: any) => {
    setInputText(e.target.value);
  };

  // Handle sending a message
  const handleSendMessage = () => {
    if (inputText.trim() === '' || isStreaming) return;
    
    sendMessage(inputText);
    setInputText('');
  };

  // Handle prompt selection
  const handlePromptSelect = (promptText: any) => {
    sendMessage(promptText);
      const content = document.querySelector('.chatbot-content');
  if (content) content.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Dictation confirmed in the speech modal used to be logged and dropped, so
  // the user watched their spoken question disappear. Send it like typed text.
  const handleVoiceMessage = (text: any) => {
    const spoken = (text || '').trim();
    if (!spoken || isStreaming) return;
    sendMessage(spoken);
    setInputText('');
  };

  return (
    <>
      {isLoggedIn && !isChatOpen && (
        <div className="chatbot-icon" onClick={toggleChat}>
          <img
            src={isDarkMode ? Icons.chatbotDark : Icons.chatbotDark}
            alt="Chat"
            title="Click to chat"
          />
        </div>
      )}
      {/* Chat panel. There used to be a second, empty .chatbot-panel above this
          one holding a "rest of chatbot UI" placeholder; it rendered over the
          real panel, and the real panel rendered even when logged out. */}
      {isLoggedIn && (
      <div className={`chatbot-panel ${isChatOpen ? 'open' : ''}`}>
        {/* Chat header */}
        <IonHeader className="chatbot-header">
          <IonToolbar>
            <div className="header-content">
              <div className="header-left">
                <button className="header-button logo-button">
                  <div className="logo-container">
                    <img src='../../assets/icon/logoIcon.svg' alt="Logo" />
                  </div>
                </button>
              </div>
              
              {/* <IonTitle>Nserix AI</IonTitle> */}
              
              <div className="header-right">
                {/* <button className="header-button" title='Prompt' onClick={showPromptPage}>
                  <img src={Icons.prompt} alt="Prompt" className="custom-icon" />
                </button> */}
                 <button className="header-button" title='Close' onClick={toggleChat}>
                  <img src={Icons.back} alt="Close" className="custom-icon" />
                </button>
                <button className="header-button" title='Add new chat' onClick={startNewChat}>
                  <img src={Icons.newChat} alt="New Chat" className="custom-icon" />
                </button>
                {/* <button className="header-button" onClick={toggleChat}>
                  <img src={Icons.chatMenu} alt="Close" className="custom-icon" />
                </button> */}
              </div>
            </div>
          </IonToolbar>
        </IonHeader>

<div className="chatbot-content">
  <div className="welcome-wrapper">
    <WelcomePrompts
      handlePromptSelect={handlePromptSelect}
      loggedInUserName={loggedInUserName}
    />
  </div>

  <div className="messages-wrapper">
    {messages.length > 0 && (
      <MessageList messages={messages} isStreaming={isStreaming} />
    )}
  </div>
</div>

        {/* Chat input */}
        <IonFooter className="chatbot-footer">
          <div className="input-container">
            <div className="input-wrapper">
              {/* <button className="plus-button">
                <img src={Icons.add} alt="Add" className="custom-icon" />
              </button> */}
              
              <IonInput
                placeholder={`Enter your prompt, ${loggedInUserName}...`}
                value={inputText}
                onIonChange={(e) => setInputText(e.detail.value || '')}
                maxlength={500}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    if (inputText.trim() !== '') {
                      handleSendMessage();
                    }
                  }
                }}
                className="message-input"
              />
              
              <SpeechToTextRecognition
                onSendVoiceMessage={handleVoiceMessage}
                inputText={inputText}
                setInputText={setInputText}
              />
            </div>
            
            <button 
              className={`send-button ${inputText.trim() === '' ? 'disabled' : ''}`}
              disabled={inputText.trim() === ''}
              onClick={handleSendMessage}
            >
              <div className="gradient-background">
                <img src={Icons.send} alt="Send" className="send-icon" />
              </div>
            </button>
          </div>
        </IonFooter>
      </div>
      )}
    </>
  );
};

export default Chatbot;